import { render } from "./lbfhdetail.vue?vue&type=template&id=0e62b7db&scoped=true&ts=true"
import script from "./lbfhdetail.vue?vue&type=script&lang=ts"
export * from "./lbfhdetail.vue?vue&type=script&lang=ts"

import "./lbfhdetail.vue?vue&type=style&index=0&id=0e62b7db&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e62b7db"]])

export default __exports__